import { Routes } from '@angular/router';
import { AccessMessageComponent } from '../pages/access-message/access-message.component';
import { LoginMitraComponent } from '../pages/login-mitra/login-mitra.component';
import { MitraGuard } from '../services/mitra.guard';
import { MitraLoginGuard } from '../services/mitra-login.guard';
import { WildcardRedirectGuard } from '../services/wildcard-redirect.guard';

export const routes: Routes = [
  { path: 'access', component: AccessMessageComponent },
  { path: 'mitra/:id', loadChildren: () => import('../pages/mitra/mitra.module').then(m => m.MitraModule), canActivate: [MitraGuard] },
  { path: 'login', component: LoginMitraComponent, canActivate: [MitraLoginGuard] },
  { path: '**', canActivate: [WildcardRedirectGuard], children: [] }
];
